import React from "react";

export const ThankYouSvg = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "129"}
      height={height || "129"}
      fill="none"
      viewBox="0 0 129 129"
    >
      <g clipPath="url(#clip0_21_700)">
        <path
          fill="#FFCC4D"
          d="M60.917 129c33.643 0 60.916-27.273 60.916-60.917 0-33.643-27.273-60.916-60.916-60.916C27.273 7.167 0 34.44 0 68.083 0 101.727 27.273 129 60.917 129z"
        ></path>
        <path
          fill="#664500"
          d="M64.496 102.125c3.958 0 7.167-4.01 7.167-8.958s-3.209-8.959-7.167-8.959c-3.958 0-7.166 4.011-7.166 8.959 0 4.947 3.208 8.958 7.166 8.958zM29.064 76.622a3.584 3.584 0 01-3.028-5.493c3.283-5.206 13.262-14.111 27.556-10.614a3.584 3.584 0 012.627 4.333 3.597 3.597 0 01-4.332 2.626c-12.915-3.16-19.716 7.367-19.784 7.475a3.589 3.589 0 01-3.039 1.673zm42.904-13.408a3.584 3.584 0 01-2.272-6.357c11.38-9.331 24.23-5.597 29.437-2.315a3.585 3.585 0 01-3.813 6.07c-.494-.3-10.936-6.532-21.084 1.788a3.555 3.555 0 01-2.268.814z"
        ></path>
        <path
          fill="#E2A62D"
          d="M47.823 112.062a2.687 2.687 0 01-2.587-3.419c1.566-5.518.925-10.854-1.756-14.641-1.78-2.516-4.317-4.053-6.962-4.222a2.684 2.684 0 01-2.516-2.848c.094-1.48 1.366-2.691 2.85-2.512 4.274.265 8.288 2.626 11.01 6.475 3.623 5.12 4.552 12.122 2.541 19.21a2.683 2.683 0 01-2.58 1.957zm39.55-10.969a2.665 2.665 0 01-1.477-.444c-4.181-2.76-6.521-7.586-6.421-13.24.104-5.86 2.899-11.299 7.11-13.865a2.68 2.68 0 013.69.9 2.68 2.68 0 01-.9 3.69c-2.633 1.606-4.457 5.372-4.529 9.367-.071 3.78 1.394 6.938 4.007 8.661a2.687 2.687 0 01-1.48 4.931z"
        ></path>
        <path
          fill="#DD2E44"
          d="M61.558 9.747c-.154-.176-.394-.273-.677-.326 0 0-57.061-10.833-59.53-8.654-2.465 2.182 1.3 60.142 1.3 60.142.019.29.083.538.24.714 2.165 2.45 17.05-7.181 33.25-21.504C52.347 25.793 63.724 12.198 61.559 9.747z"
        ></path>
        <path
          fill="#EA596E"
          d="M1.25.971c-.053.108-.1.255-.136.44.57 4.914 6.074 45.337 9.503 57.972 5.146-2.877 10.374-6.787 16.516-11.657C21.916 38.176 4.149.523 1.25.971z"
        ></path>
        <path
          fill="#3B88C3"
          d="M107.149 104.737l-37.887-4.669c-4.049-.365-11.17-.401-10.804-6.815.334-5.816 7.31-4.92 12.467-4.157l38.119 6.357-1.895 9.284z"
        ></path>
        <path
          fill="#88C9F9"
          d="M109.041 95.456l-15.129-2.594c-1.77-.319-3.347 2.319-3.425 5.11-.09 3.103.813 4.673 2.601 5.038l14.849 1.835 1.104-9.389z"
        ></path>
        <path
          fill="#3B88C3"
          d="M125.123 94.389l-9.396 8.639-16.795-18.264 9.396-8.64c4.877-4.486 12.538-4.163 17.024.713l.484.527c4.483 4.88 4.164 12.538-.713 17.025z"
        ></path>
        <path
          fill="#88C9F9"
          d="M115.721 103.033c4.036-3.71 3.548-10.807-1.089-15.85-4.638-5.044-11.668-6.125-15.704-2.414-4.035 3.71-3.547 10.806 1.09 15.85 4.637 5.044 11.668 6.124 15.703 2.414z"
        ></path>
        <path
          fill="#269"
          d="M112.362 99.38c2.018-1.856 1.399-5.812-1.384-8.838-2.782-3.026-6.673-3.975-8.69-2.12-2.018 1.855-1.398 5.812 1.384 8.838 2.782 3.026 6.673 3.975 8.69 2.12z"
        ></path>
        <path
          fill="#55ACEE"
          d="M8.959 125.417a5.375 5.375 0 10-.001-10.75 5.375 5.375 0 000 10.75zM103.917 14.333a7.166 7.166 0 007.166-7.166 7.166 7.166 0 10-14.333 0 7.167 7.167 0 007.167 7.166z"
        ></path>
        <path
          fill="#EA596E"
          d="M17.43 104.798L9.052 84.674l-7.575 21.661 15.953-1.537zm75.737-86.881L78.834 21.5l3.583-14.333 10.75 10.75z"
        ></path>
        <path
          fill="#77B255"
          d="M114.663 46.583L129 28.663 118.25 21.5l-3.587 25.083z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_21_700">
          <path fill="#fff" d="M0 0H129V129H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );

};
